var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#0098FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 34.6667C50.488 34.6667 54.6667 30.488 54.6667 25.3333C54.6667 20.1787 50.488 16 45.3333 16C40.1787 16 36 20.1787 36 25.3333C36 30.488 40.1787 34.6667 45.3333 34.6667Z",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 21.3333C47.5414 21.3333 49.3334 23.124 49.3334 25.3333",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50.6666C24 49.9303 23.4031 49.3333 22.6667 49.3333V49.3333C21.9303 49.3333 21.3334 49.9303 21.3334 50.6666V50.6666C21.3334 51.403 21.9303 52 22.6667 52V52C23.4031 52 24 51.403 24 50.6666V50.6666Z",
    fill: "#0098FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 81.3333L32 86.6666",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3333 81.3333L58.6666 86.6666",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86.6667H73.3333",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3333 86.6667H83.9999",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9373 86.6666L64.7053 75.964C70.6333 72.2773 74.6666 66.7413 74.6666 58.6666C74.6666 47.3933 67.992 40.2813 58.0546 37.3933C57.9173 37.3533 57.772 37.3333 57.628 37.3333C56.7293 37.3346 56 38.1693 56 39.2V42.6666H34.6666V39.1C34.6666 38.1253 33.976 37.3346 33.1253 37.3346C32.9906 37.3346 32.8546 37.3546 32.724 37.392C24.84 39.6813 18.932 44.5213 16.564 52.048L12.1013 53.02C11.264 53.2026 10.6666 53.944 10.6666 54.8026V62.5306C10.6666 63.3893 11.264 64.1306 12.1026 64.3133L16.692 65.3106C18.2746 69.9026 21.4626 73.42 25.5546 75.9653L23.7733 86.6666",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 56L45.3333 57.3333",
    stroke: "#0098FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 68V70.6667",
    stroke: "#0098FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 65.6667C41.3333 66.9547 43.1239 68 45.3333 68C47.5413 68 49.3333 66.9547 49.3333 65.6667C49.3333 64.3787 47.5413 63.3334 45.3333 63.3334C43.1239 63.3334 41.3333 62.288 41.3333 61C41.3333 59.712 43.1239 58.6667 45.3333 58.6667C47.5413 58.6667 49.3333 59.712 49.3333 61",
    stroke: "#0098FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 76C52.6971 76 58.6667 70.0304 58.6667 62.6666C58.6667 55.3028 52.6971 49.3333 45.3333 49.3333C37.9695 49.3333 32 55.3028 32 62.6666C32 70.0304 37.9695 76 45.3333 76Z",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 37.3574C86.6667 41.0387 82.3493 44 78.6667 44C74.984 44 72 42.348 72 38.6667C72 38.18 72.1307 37.724 72.3573 37.332",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72 38.6667C72 38.18 72.1307 37.724 72.3573 37.332C72.8173 36.536 73.68 36 74.6667 36C78.6667 36 81.3333 38.6667 81.3333 42.6667C81.3333 46.1587 79.6827 49.8333 73.3547 50.6667",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 16H12",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H25.3333",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20V25.3333",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66669V12",
    stroke: "#0098FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalet);
export default __webpack_public_path__ + "static/media/walet.fb462ce5e2091a8e6dc92bc92369a40d.svg";
export { ForwardRef as ReactComponent };